import { css } from "@compiled/react";
import { FormattedMessage, useIntl } from "react-intl";

import UFOSegment from "@atlassian/wac-ufo-segment";

import { Adg4Button } from "@/components/adg4/button/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import { Ai } from "@/patterns/adg4/ai-section";

const AISection = () => {
    const intl = useIntl();
    return (
        <UFOSegment name="confluence-pt-cfind-1234-aiSection">
            <div
                css={css({
                    ".video-container": {
                        height: "407px",
                        padding: "0px 54px"
                    },
                    ".burst-container1": {
                        position: "absolute",
                        insetInlineStart: "10%"
                    },
                    ".burst-container2": {
                        position: "absolute",
                        insetInlineEnd: "50px"
                    },
                    ".video": {
                        height: "auto",
                        padding: "0px 109px"
                    }
                })}
            >
                <Ai
                    theme="light"
                    title={intl.formatMessage({
                        id: "ConfluenceSoftwarePage.v4.AISection.title",
                        defaultMessage: "Leave the busywork to AI"
                    })}
                    videoLink="https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/artificial-intelligence/Smart+Answers+in+Confluence+Search-4k.mp4"
                    analyticsEventLabel="atlas-55799-ai-button-clicked"
                    includeFooter={false}
                    button={
                        <Adg4Button
                            variant="secondary"
                            color="black"
                            size="large"
                            href={useLocalizedHref(
                                "/software/artificial-intelligence"
                            )}
                            onClick={() => null}
                        >
                            <FormattedMessage
                                id="ConfluenceSoftwarePage.v4.AISection.button"
                                defaultMessage="Explore Atlassian Intelligence"
                            />
                        </Adg4Button>
                    }
                    buttonPosition="bottom"
                    videoContainerClassName={"video-container"}
                    showBurst={true}
                    burstClassName1={"burst-container1"}
                    burstClassName2={"burst-container2"}
                    videoClassName={"video"}
                />
            </div>
        </UFOSegment>
    );
};

AISection.displayName = "AISection";

export default AISection;
